let googleMapsPromise = null;

function createGoogleMapsUrl(apiKey, callbackName) {
	const params = new URLSearchParams({
		key: apiKey,
		libraries: 'places',
		loading: 'async',
		v: 'weekly',
		callback: callbackName,
	});

	return `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
}

export function loadGoogleMapsPlaces(apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY) {
	if (typeof window === 'undefined') {
		return Promise.reject(new Error('Google Maps can only load in the browser.'));
	}

	if (window.google?.maps?.places) {
		return Promise.resolve(window.google);
	}

	if (!apiKey) {
		return Promise.reject(
			new Error('Missing REACT_APP_GOOGLE_MAPS_KEY environment variable.')
		);
	}

	if (googleMapsPromise) {
		return googleMapsPromise;
	}

	googleMapsPromise = new Promise((resolve, reject) => {
		const callbackName = `__bncGoogleMapsInit_${Date.now()}`;
		const existingScript = document.querySelector(
			'script[data-google-maps-loader="bnc"]'
		);

		const cleanup = () => {
			delete window[callbackName];
		};

		window[callbackName] = () => {
			cleanup();

			if (window.google?.maps?.places) {
				resolve(window.google);
				return;
			}

			googleMapsPromise = null;
			reject(new Error('Google Maps loaded without the Places library.'));
		};

		const handleScriptError = () => {
			cleanup();
			googleMapsPromise = null;
			reject(new Error('Unable to load Google Maps right now.'));
		};

		if (existingScript) {
			existingScript.remove();
		}

		const script = document.createElement('script');
		script.src = createGoogleMapsUrl(apiKey, callbackName);
		script.async = true;
		script.defer = true;
		script.dataset.googleMapsLoader = 'bnc';
		script.addEventListener('error', handleScriptError, { once: true });
		document.head.appendChild(script);
	});

	return googleMapsPromise;
}
